setTimeout(() => {
  const swatches = document.getElementsByClassName("variant-picker");
  for (let i = 0; i < swatches.length; i++) {
    swatches[i].addEventListener("click", getDiscountedPrice);
  }
}, 1000);

function getDiscountedPrice() {
  setTimeout(() => {  
    
    
      var oldVariant = document.getElementsByClassName("axt-cp-custom")[0].id;
      var oldProduct = document
        .getElementsByClassName("axt-cp-custom")[0]
        .getAttribute("axt-cp-product-id");
     
      var variantId = document.querySelectorAll('[name="id"]')[2]?.value;
      if(!variantId){
        variantId = document.querySelectorAll('[name="id"]')[1]?.value;
      }
      
      if(!variantId){
        variantId = document.querySelectorAll('[name="id"]')[0]?.value;
      }
    
      var productId = document.querySelector('[name="product-id"]').value;
  
      document
        .getElementsByClassName("axt-cp-custom")[0]
        .classList.remove(oldVariant);
     
      document.getElementsByClassName("axt-cp-custom")[0].classList.add(variantId);
      document
        .getElementsByClassName("axt-cp-custom")[0]
        .setAttribute("axt-cp-product-id", variantId);
  }, 1000);
}
